module.exports = __webpack_public_path__ + "img/1.1917cf1f.jpeg";